($ =>{
  const row_content = [
    '<td>094201</td>',
    '<td>Aliquam vel blandit elit. Phasellus eu leo in dolor safittis luctus. Duis at fringilla est, ut pretium lacus.</td>',
    '<td>Presencial</td>',
    '<td>Ourense</td>',
    '<td>20/2/18</td>',
    '<td>25/2/18</td>',
    '<td>22</td>',
    '<td>15</td>',
    '<td class="table-row-opts"><a href="#" title="Ver listado" class="btn table-row-opt"><i class="fa fa-eye"></i></a></td>',
  ];

  var settings = {
    imgLoad: "assets/images/logos/loading.svg",
    nItems: '10',
    max_width: '992',
  }, loadBlock = $('<div class="row loading"><img src="' + settings.imgLoad + '" class="logo"></div>');

  /**
   * Check if the layout corresponds to mobile or tablet
   * @returns {boolean}
   */
  function isBreakPoint() {
    return $(window).width() <= settings.max_width;
  }

  /**
   * Add load gif
   * @param element parent of the load gif
   */
  function addLoadImage(element) {
    element.append(loadBlock);
  }

  /**
   * Destoy the load gif
   * @param element parent of the load gif
   */
  function destroyLoadImage(element) {
    element.find('.loading').remove();
  }

  /**
   * Add content to the table
   * @param element tbody element of the table
   */
  function addItems(element) {
    if (isBreakPoint()){
      for (var i = 0; i < settings.nItems; i++){
        element.children().each(function (index, value) {
          $(this).append($(row_content[index]));
        });
      }
    } else {
      for (var i = 0; i < settings.nItems; i++){
        var row = $('<tr></tr>');
        $.each(row_content, function (index, value ){
          row.append($(value));
        });
        element.append(row);
      }
    }
  }

  /**
   * Add content to the table
   * @param element tbody element of the table
   */
  function load(element) {
    var table_wrapper = element.parent().parent().parent();
    addLoadImage(table_wrapper);
    setTimeout(function () {
      destroyLoadImage(table_wrapper);
      addItems(element, 20);
    }, 1000);
  }

  $.fn.infiniteScroll = function(options){
    settings = $.extend({}, settings, options );
    var tbody = this;

    this.ready(function() {
      load(tbody);
    });

    $('body').scroll(function() {
      if (!isBreakPoint()){
        var scrollHeight = $(document).height();
        var scrollPosition = $('body').height() + $('body').scrollTop();
        if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
          load(tbody);
        }
      }
    });
    $('#infinite tbody').scroll(function() {
      if (isBreakPoint()) {
        var width = tbody.width();
        var scrollWidth = tbody[0].scrollWidth;
        var scrollPosition = tbody.scrollLeft();
        if (scrollWidth - (width + scrollPosition) === 0) {
          load(tbody);
        }
      }
    });
  };

})(jQuery);



// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/infinite-scroll-demo.js